<div class="fz-view-mode__root">
  <div class="fz-view-mode__root__indicator" #indRef></div>
  <button
    mat-button
    class="fz-view-mode__option"
    data-test="view-mode-list"
    data-ga-value="user-select-view-mode-list"
    matTooltip="Change view mode to list."
    [class.fz-view-mode__option__selected]="viewMode() === ViewMode.List"
    (click)="
      viewMode() === ViewMode.List ? null : toggleViewMode(ViewMode.List)
    "
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_9275_193368)">
        <path
          d="M4 10.5C3.17 10.5 2.5 11.17 2.5 12C2.5 12.83 3.17 13.5 4 13.5C4.83 13.5 5.5 12.83 5.5 12C5.5 11.17 4.83 10.5 4 10.5ZM4 4.5C3.17 4.5 2.5 5.17 2.5 6C2.5 6.83 3.17 7.5 4 7.5C4.83 7.5 5.5 6.83 5.5 6C5.5 5.17 4.83 4.5 4 4.5ZM4 16.5C3.17 16.5 2.5 17.18 2.5 18C2.5 18.82 3.18 19.5 4 19.5C4.82 19.5 5.5 18.82 5.5 18C5.5 17.18 4.83 16.5 4 16.5ZM7 19H21V17H7V19ZM7 13H21V11H7V13ZM7 5V7H21V5H7Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_9275_193368">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  </button>
  <button
    mat-button
    class="fz-view-mode__option"
    data-test="view-mode-grid"
    data-ga-value="user-select-view-mode-grid"
    matTooltip="Change view mode to cards."
    [class.fz-view-mode__option__selected]="viewMode() === ViewMode.grid"
    (click)="
      viewMode() === ViewMode.grid ? null : toggleViewMode(ViewMode.grid)
    "
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <g clip-path="url(#clip0_9275_193371)">
        <rect x="3" y="3" width="4" height="4" rx="1" fill="currentColor" />
        <rect x="3" y="10" width="4" height="4" rx="1" fill="currentColor" />
        <rect x="10" y="3" width="4" height="4" rx="1" fill="currentColor" />
        <rect x="10" y="10" width="4" height="4" rx="1" fill="currentColor" />
        <rect x="17" y="3" width="4" height="4" rx="1" fill="currentColor" />
        <rect x="17" y="10" width="4" height="4" rx="1" fill="currentColor" />
        <rect x="3" y="17" width="4" height="4" rx="1" fill="currentColor" />
        <rect x="10" y="17" width="4" height="4" rx="1" fill="currentColor" />
        <rect x="17" y="17" width="4" height="4" rx="1" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_9275_193371">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  </button>
</div>
